export default "__VITE_ASSET__B_e89_5S__"